import { SessionService, UserDirectoryService } from "@edl-development/edl-common";
import { Ng2StateDeclaration } from "@uirouter/angular";
import { Transition } from "@uirouter/core";
import { firstValueFrom } from "rxjs";
import { ItemPacketService } from "src/app/services/item-packet/item-packet.service";
import { VolunteerReportHelperService } from "src/app/services/volunteer/volunteer-report-helper.service";
import { VolunteerReportService } from "src/app/services/volunteer/volunteer-report.service";
import { ReportsComponent } from "../../reports.component";
import { InComplianceReportComponent } from "./in-compliance-report/in-compliance-report.component";


export function resolveReportContent(volunteerReportHelperService: VolunteerReportHelperService, volunteerReportService: VolunteerReportService, transition: Transition) {
    const request = getReportRequest(volunteerReportHelperService, transition);
    return firstValueFrom(volunteerReportService
        .getInComplianceReport(request));
}

export function getReportRequest(volunteerReportHelperService: VolunteerReportHelperService, transition: Transition) {
    const params = transition.params();
    const { searchBy, currentPage, itemPacket, orderBy, ascending, volunteerAreas } = params;
    return volunteerReportHelperService.getReportRequest({ searchBy, page: currentPage, limit: 20, itemPacket, orderBy, ascending, volunteerAreas });
}

export function resolveItemPackets(itemPacketsService: ItemPacketService, sessionService: SessionService) {
    const userId = sessionService.user.UserID !== undefined ? sessionService.user.UserID : null;
    return userId !== null ?
        firstValueFrom(itemPacketsService.getAllPackets()) :
        Promise.resolve([]);
}

export function resolveSearchCriteria(sessionService: SessionService, userDirectoryService: UserDirectoryService) {
    let user = sessionService.user;
    return userDirectoryService
        .getSearchCriteria(user.UserPortal.PortalID).toPromise();
}

export let VolunteerReportStates: Ng2StateDeclaration[] = [{
    name: 'authenticated.reports.volunteer',
    url: '/volunteer',
    views: {
        'content@authenticated': {
            component: ReportsComponent
        }
    }
}, {
    name: 'authenticated.reports.volunteer.in-compliance',
    url: '/in-compliance?currentPage?orderBy&ascending&itemPacket&volunteerAreas&searchBy', //:page?orderBy&ascending&archived&itemPackets',
    views: {
        'content@authenticated': {
            component: InComplianceReportComponent
        }
    },
    params: {
        currentPage: {
            type: 'int',
            value: 1,
        },
        itemPacket: {
            raw: true,
            value: '',
        },
        searchBy: {
            raw: true,
            value: '',
        },
        volunteerAreas: {
            raw: true,
            type: 'string',
            array: true,
            value: []
        },
        getAllResults:{
            raw: true,
            type: 'bool',
            value: false
        }
    },
    resolve: [
        {
            token: 'pagedResponse',
            deps: [VolunteerReportHelperService, VolunteerReportService, Transition],
            resolveFn: resolveReportContent,
        },
        {
            token: 'itemPackets',
            deps: [ItemPacketService, SessionService],
            resolveFn: resolveItemPackets
        }, {
            token: 'searchCriteria',
            deps: [SessionService, UserDirectoryService],
            resolveFn: resolveSearchCriteria
        }, {
            token: 'request',
            deps: [VolunteerReportHelperService, Transition],
            resolveFn: getReportRequest
        }]
}];